import * as React from "react";
import { UitkInput } from "./index.js";
export class UitkTextInput extends React.Component {
  static displayName = "UitkTextInput";
  render() {
    return /* @__PURE__ */ React.createElement(UitkInput, { ...this.props, type: "text" });
  }
}
